import { useCallback, useEffect, useState } from 'react';
import { mailError } from '../mailboxModel';
import { fetchLabels } from '../models/mailApi';

export function useMailLabels(enabled, profile, revision, socket) {
  const [labels, setLabels] = useState([]);
  const [labelsError, setLabelsError] = useState('');
  const [labelsRevision, setLabelsRevision] = useState(0);
  const refreshLabels = useCallback(() => setLabelsRevision(value => value + 1), []);
  useEffect(() => {
    if (!enabled || !profile) return undefined;
    let active = true;
    fetchLabels().then(data => {
      if (active) { setLabels(data); setLabelsError(''); }
    }).catch(failure => {
      if (active) { setLabels(current => current.map(label => ({ ...label, messages_unread: null, messages_total: null }))); setLabelsError(mailError(failure)); }
    });
    return () => { active = false; };
  }, [enabled, profile, revision, labelsRevision]);
  useEffect(() => {
    if (!enabled || !profile) return undefined;
    socket?.on('connect', refreshLabels);
    window.addEventListener('focus', refreshLabels);
    return () => { socket?.off('connect', refreshLabels); window.removeEventListener('focus', refreshLabels); };
  }, [enabled, profile, socket, refreshLabels]);
  const inboxUnread = enabled ? labels.find(label => label.id === 'INBOX')?.messages_unread ?? null : null;
  return { labels, labelsError, refreshLabels, inboxUnread };
}
